import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { environmentURLs } from '../../../components/common/CaptureEnvironment';
import { client } from '../../../utils/apolloClient';

const initialState = {
    dealerPurchaseHistoryData:[],
    dealerPurchaseHistoryDataLoaded:false,
    errorInGettingDealerPurchaseHistroyData:false,
    dealerPurchaseHistoryDataLoading:false

};
export const getDealerPurchaseReport = createAsyncThunk(
  'getDealerPurchaseReport',
  async ({userEmail,startDate,endDate,token}) => {
    let response = await client.authorizeRequest({
      method: 'GET',
      url: `${environmentURLs.REACT_APP_PAYMENT_SERVICE}/report/dealer-purchase?userEmail=${userEmail}&startDate=${startDate}&endDate=${endDate}`,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
);

export const dealerPurchaseHistorySlice = createSlice({
  name: 'dealerPurchaseHistorySlice',
  initialState,
  reducers: {},
  extraReducers: {
    [getDealerPurchaseReport.fulfilled]: (state, action) => {
    state.dealerPurchaseHistoryData = action.payload;
    state.dealerPurchaseHistoryDataLoaded = true;
    state.dealerPurchaseHistoryDataLoading = false;
    state.errorInGettingDealerPurchaseHistroyData=false;
    },
    [getDealerPurchaseReport.pending]: (state, action) => {
    state.dealerPurchaseHistoryDataLoaded = false;
    state.dealerPurchaseHistoryDataLoading = true;
    state.errorInGettingDealerPurchaseHistroyData=false;
    },
    [getDealerPurchaseReport.rejected]: (state, action) => {
    state.errorInGettingDealerPurchaseHistroyData = true;
    state.dealerPurchaseHistoryDataLoaded = false;
    state.dealerPurchaseHistoryData = [];
    state.dealerPurchaseHistoryDataLoading = false;
    }
  }
});

export default dealerPurchaseHistorySlice.reducer;